<template>
  <div class="v17-vproject-bar-left">
    <f-sexy-scroll>
      <f-list-item
        v-for="(tab, index) in sortedTabs"
        :key="tab['#id']"
        class="vproject17-list-item"
        :class="{ selected: currentTab == tab, separator: tab.separator }"
        :icon="tab.icon"
        :selected="currentTab == tab"
        :tooltip="tab.tooltip"
        :href="'#' + path + '#' + index"
      >{{ $vt(tab.title) }}</f-list-item>
    </f-sexy-scroll>
  </div>
</template>
<script>
export default {
  props: ["tabs", "currentTab", "path"],
  computed: {
    sortedTabs() {
      return Object.values(this.tabs).sort((a, b) => a.weight - b.weight);
    },
  },
};
</script>

<style lang="scss">
div.v17-vproject-bar-left {
  width: 96px;
  height: 100%;
  flex: 0 0 auto;
  background-color: var(--black);
  color: #ffffff;
  grid-row: 2 / 4;
  grid-column: 1;
  display: flex;
  flex-direction: column;

  .f-sexy-scroll
  {
    height: 0;
    flex: 1 1 auto;
    overflow-x: hidden;
  }

  .vfigma-list-item {
	margin-right:2px;
	
  }
  
  .vproject17-list-item.separator {
	border-bottom: solid 1px var(--white-a10);
  }
}
</style>
